import { render, staticRenderFns } from "./BrowseCard.vue?vue&type=template&id=525dcb5a&scoped=true&"
import script from "./BrowseCard.vue?vue&type=script&lang=ts&"
export * from "./BrowseCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseCard.vue?vue&type=style&index=0&id=525dcb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dcb5a",
  null
  
)

export default component.exports